import { useCallback, useEffect, useState } from 'react';
export const useAnimationDisplay = value => {
  const [visualValue, setVisualValue] = useState();
  useEffect(() => {
    if (value) {
      setVisualValue(value);
    }
  }, [value]);
  const animationEnd = useCallback(() => {
    if (!value) {
      setVisualValue(undefined);
    }
  }, [value]);
  return {
    value: visualValue,
    animationEnd
  };
};